<template>
  <Modal
    v-model="innerVisible"
    title="每日签到"
    width="760"
    :mask-closable="true"
    class="sign-in-modal"
  >
    <div class="sign-in-panel">
      <div class="sign-in-banner">
        <div>
          <div class="sign-in-title">本周签到奖励</div>
          <div class="sign-in-subtitle">
            今日{{ todayLabel }}，可领取 <span class="sign-in-highlight">玄晶 x{{ todayReward.rewardCount }}</span>
          </div>
        </div>
        <Tag :color="isSignedToday ? 'success' : 'warning'">
          {{ isSignedToday ? '今日已签到' : '今日未签到' }}
        </Tag>
      </div>

      <div class="sign-in-grid">
        <div
          v-for="day in signRewards"
          :key="day.weekday"
          :class="[
            'sign-in-card',
            { 'is-today': day.weekday === todayWeekday, 'is-signed': isSignedToday && day.weekday === todayWeekday }
          ]"
        >
          <div class="sign-in-day">{{ day.label }}</div>
          <div class="sign-in-item-icon">玄</div>
          <div class="sign-in-item-name">{{ day.rewardName }}</div>
          <div class="sign-in-item-count">x{{ day.rewardCount }}</div>
          <div v-if="day.weekday === todayWeekday" class="sign-in-status">
            {{ isSignedToday ? '已领取' : '今日奖励' }}
          </div>
        </div>
      </div>

      <div class="sign-in-tips">
        奖励按周一到周日递增，当前方案为固定展示；后续如改奖励配置，可再切成后端驱动。
      </div>
    </div>
    <div slot="footer">
      <Button @click="innerVisible = false">关闭</Button>
      <Button type="primary" :loading="signing" :disabled="isSignedToday" @click="handleSignIn">
        {{ isSignedToday ? '今日已领取' : '立即签到' }}
      </Button>
    </div>
  </Modal>
</template>

<script>
export default {
  name: "SignInModal",
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      innerVisible: this.value,
      signing: false,
      isSignedToday: false,
      signRewards: [
        { weekday: 1, label: "周一", rewardName: "玄晶", rewardCount: 1 },
        { weekday: 2, label: "周二", rewardName: "玄晶", rewardCount: 2 },
        { weekday: 3, label: "周三", rewardName: "玄晶", rewardCount: 3 },
        { weekday: 4, label: "周四", rewardName: "玄晶", rewardCount: 4 },
        { weekday: 5, label: "周五", rewardName: "玄晶", rewardCount: 5 },
        { weekday: 6, label: "周六", rewardName: "玄晶", rewardCount: 6 },
        { weekday: 7, label: "周日", rewardName: "玄晶", rewardCount: 7 }
      ]
    };
  },
  computed: {
    todayWeekday() {
      const day = new Date().getDay();
      return day === 0 ? 7 : day;
    },
    todayLabel() {
      const current = this.signRewards.find((item) => item.weekday === this.todayWeekday);
      return current ? current.label : "今日";
    },
    todayReward() {
      return this.signRewards.find((item) => item.weekday === this.todayWeekday) || this.signRewards[0];
    }
  },
  watch: {
    value(val) {
      this.innerVisible = val;
      if (val) {
        this.syncSignedState();
      }
    },
    innerVisible(val) {
      this.$emit("input", val);
      if (val) {
        this.syncSignedState();
      }
    }
  },
  methods: {
    getCharaId() {
      if (typeof this.getCookie === "function") {
        return this.getCookie("charaId");
      }
      return "";
    },
    getTodayKey() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const day = String(now.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    getStorageKey() {
      const charaId = this.getCharaId() || "anonymous";
      return `signInDaily:${charaId}:${this.getTodayKey()}`;
    },
    syncSignedState() {
      this.isSignedToday = window.localStorage.getItem(this.getStorageKey()) === "1";
    },
    markSignedToday() {
      window.localStorage.setItem(this.getStorageKey(), "1");
      this.isSignedToday = true;
    },
    handleSignIn() {
      if (this.signing || this.isSignedToday) {
        return;
      }

      const charaId = this.getCharaId();
      if (!charaId) {
        this.$Message.warning("角色信息失效，请重新登录");
        return;
      }

      this.signing = true;
      this.$http
        .post(`/gamepassport/signInDaily?charaId=${charaId}&signType=1`)
        .then((res) => {
          const { status, data, msg } = res.data || {};
          const message = data || msg || "签到完成";

          if (status === 200) {
            this.markSignedToday();
            this.$Message.success(message);
            this.$emit("sign-success", {
              weekday: this.todayWeekday,
              reward: this.todayReward
            });
            return;
          }

          if (message.indexOf("已签到") !== -1) {
            this.markSignedToday();
          }
          this.$Message.warning(message);
        })
        .catch(() => {
          this.$Notice.warning({ title: "提示", desc: "签到失败,请联系管理员" });
        })
        .finally(() => {
          this.signing = false;
        });
    }
  },
  mounted() {
    this.syncSignedState();
  }
};
</script>

<style scoped>
.sign-in-panel {
  color: #17233d;
}

.sign-in-banner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin-bottom: 18px;
  padding: 16px 18px;
  border: 1px solid #e8eaec;
  border-radius: 12px;
  background: #fff;
}

.sign-in-title {
  font-size: 18px;
  font-weight: 600;
  color: #17233d;
}

.sign-in-subtitle {
  margin-top: 6px;
  font-size: 14px;
  color: #657180;
}

.sign-in-highlight {
  color: #2d8cf0;
  font-weight: 600;
}

.sign-in-grid {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  gap: 12px;
}

.sign-in-card {
  position: relative;
  padding: 16px 10px 14px;
  border: 1px solid #e8eaec;
  border-radius: 12px;
  text-align: center;
  background: #fff;
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
}

.sign-in-card.is-today {
  border-color: #2d8cf0;
  box-shadow: 0 8px 18px rgba(45, 140, 240, 0.12);
}

.sign-in-card.is-signed {
  background: #f6ffed;
  border-color: #52c41a;
}

.sign-in-day {
  font-size: 15px;
  font-weight: 600;
  color: #515a6e;
}

.sign-in-item-icon {
  width: 48px;
  height: 48px;
  margin: 12px auto 10px;
  border: 1px solid #dcdfe6;
  border-radius: 12px;
  background: #f8f8f9;
  color: #2d8cf0;
  font-size: 22px;
  font-weight: 600;
  line-height: 48px;
}

.sign-in-item-name {
  font-size: 14px;
  color: #657180;
}

.sign-in-item-count {
  margin-top: 4px;
  font-size: 22px;
  font-weight: 600;
  color: #17233d;
}

.sign-in-status {
  margin-top: 10px;
  font-size: 12px;
  color: #808695;
}

.sign-in-card.is-signed .sign-in-status {
  color: #389e0d;
  font-weight: 600;
}

.sign-in-tips {
  margin-top: 16px;
  font-size: 12px;
  color: #808695;
}

@media (max-width: 768px) {
  .sign-in-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sign-in-banner {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SignInModal.vue